import React from 'react'
import BackButton from '../BackButton/BackButton'
import Mainmenubtn from '../MainMenuBtn/Mainmenubtn'
import '../../App.css';

export default function NavbarGame() { 
    return (
        <nav className="main-headers">
            
            <h1 className="">BRAINIFY</h1>
           
        </nav>
    )
}
